<template>
  <div>
    <el-table
      stripe
      :data="ptos"
      :default-sort = "{prop: 'created_at', order: 'descending'}"
      style="width: 100%"
      v-if="count > 0"
      :border="true"
      class="depth">

      <el-table-column
        prop="user.profile.first_name"
        v-if="!this.user_id && showColumns.name"
        label="Name" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.user.profile">
            {{ scope.row.user.profile.first_name }} {{ scope.row.user.profile.last_name }}
          </span>
          <span v-else>
            <i>[User's name is not set yet]</i>
          </span>
        </template>
      </el-table-column>

      <el-table-column
        label="Status"
        v-if="showColumns.status" align="center" sortable>
        <template slot-scope="scope">
          <el-tag size="small" :type="setType(scope.row)" effect="dark">{{ setValue(scope.row) }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="category.name"
        label="Category"
        v-if="showColumns.category" align="center" sortable>
      </el-table-column>

      <el-table-column
        prop="starts_at"
        label="Start"
        v-if="showColumns.start" align="right" sortable>
        <template slot-scope="scope">
          {{ scope.row.starts_at | formatTime('MMMM DD, YYYY hh:mm a') }}
        </template>
      </el-table-column>

      <el-table-column
        prop="ends_at"
        label="End"
        v-if="showColumns.end" align="right" sortable>
        <template slot-scope="scope">
          {{ scope.row.ends_at | formatTime('MMMM DD, YYYY hh:mm a') }}
        </template>
      </el-table-column>

      <el-table-column
        prop="created_at"
        label="Requested"
        v-if="showColumns.requested" align="right" sortable>
        <template slot-scope="scope">
          {{ scope.row.created_at | formatTime('MMMM DD, YYYY hh:mm a') }}
        </template>
      </el-table-column>

      <el-table-column
        prop="requested_offdays"
        label="Duration"
        v-if="showColumns.duration" align="center" sortable>
        <template slot-scope="scope">
          {{ scope.row.requested_offdays }} day(s)
        </template>
      </el-table-column>

      <el-table-column
        label=""
        width="100"
        v-if="showColumns.actions" align="center">
        <template slot-scope="scope">
          <router-link :to="{ name: 'pto', params: { id: scope.row.id } }"><el-button type="primary" size="mini"><i class="fas fa-search"></i></el-button></router-link>
        </template>
      </el-table-column>

    </el-table>

    <div v-else>
      <el-alert type="info" :closable="false" title="There are no PTO entries!" center></el-alert>
    </div>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import CalendarService from '@/services/calendarService';

  export default {
    name: 'PtosList',
    props: {
      ptos: {
        type: Array,
        required: true,
      },
      user_id: {
        type: Number,
      },
      showColumns: {
        type: Object,
        required: false,
        default: () => ({ status: true, name: true, category: true, start: true, end: true, requested: true, duration: true, actions: true }),
      },
    },
    computed: {
      ...mapGetters('entities/users', ['currentUser']),
      count() {
        return this.ptos ? this.ptos.length : 0;
      },
    },
    methods: {
      getDays(date1, date2) {
        return CalendarService.getDays(date1, date2);
      },
      getHours(date1, date2) {
        return CalendarService.getHours(date1, date2);
      },
      setType(pto) {
        if (pto) {
          switch (pto.status) {
            case 'approved':
              return 'success';
            case 'rejected':
              return 'danger';
            case 'pending':
              return 'warning';
            default:
              return 'info';
          }
        }
        return 'info';
      },
      setValue(pto) {
        if (pto) {
          switch (pto.status) {
            case 'approved':
              return 'Approved';
            case 'rejected':
              return 'Rejected';
            case 'pending':
              return 'Pending';
            default:
              return 'Not Submitted';
          }
        }
        return 'Not Submitted';
      },
    },
  };
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pto/PtosList.vue